var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25064 3.63362L13.6506 8.03362C13.7173 8.10028 13.7646 8.17251 13.7926 8.25029C13.8206 8.32806 13.8344 8.4114 13.834 8.50029C13.834 8.58917 13.82 8.67251 13.792 8.75029C13.764 8.82806 13.7169 8.90028 13.6506 8.96695L9.25064 13.367C9.12842 13.4892 8.97553 13.553 8.79197 13.5583C8.60842 13.5636 8.4502 13.4998 8.31731 13.367C8.18397 13.2447 8.11442 13.0918 8.10864 12.9083C8.10286 12.7247 8.16686 12.5665 8.30064 12.4336L11.5673 9.16695H4.11731C3.92842 9.16695 3.76997 9.10295 3.64197 8.97495C3.51397 8.84695 3.4502 8.68873 3.45064 8.50029C3.45064 8.3114 3.51442 8.15295 3.64197 8.02495C3.76953 7.89695 3.92797 7.83317 4.11731 7.83362L11.5673 7.83362L8.30064 4.56695C8.17842 4.44473 8.11442 4.28917 8.10864 4.10028C8.10286 3.9114 8.16686 3.75584 8.30064 3.63362C8.42286 3.50029 8.57842 3.43362 8.76731 3.43362C8.9562 3.43362 9.11731 3.50029 9.25064 3.63362Z",
    fill: "#0B93E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/arrow-right-blue.b1451a95c194422000d3a9245164a8e9.svg";
export { ForwardRef as ReactComponent };